import { Button, Icon, ButtonProps } from '@chakra-ui/react';
import { PrinterIcon } from '@heroicons/react/24/outline';
import { useCallback } from 'react';

interface PrintButtonProps extends ButtonProps {
  documentTitle?: string;
}

export default function PrintButton({
  documentTitle,
  children = 'Print',
  ...props
}: PrintButtonProps) {
  const handlePrint = useCallback(() => {
    // Set document title for print job if provided
    if (documentTitle) {
      const originalTitle = document.title;
      document.title = documentTitle;

      window.print();

      // Reset title after print dialog closes
      setTimeout(() => {
        document.title = originalTitle;
      }, 100);
    } else {
      window.print();
    }
  }, [documentTitle]);

  return (
    <Button
      colorPalette='brand'
      variant='outline'
      size='sm'
      onClick={handlePrint}
      className='no-print' // This class will hide the button when printing
      {...props}
    >
      {children}
      <Icon as={PrinterIcon} w={4} h={4} />
    </Button>
  );
}
